import { useLazyQuery, useQuery } from "@apollo/client/react"; import { Box, Grid } from '@mui/material';
import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import ProfesionalField from './components/searchFields/ProfesionalField';
import PacienteField from './components/searchFields/PacienteField';
import FinanciadorField from './components/searchFields/FinanciadorField';
import GrillaProductosField from './components/GrillaProductosField';
import moment from 'moment';
import { GroupedContainer } from '../../../ContratosCreation/components/GroupedContainer';

import { adaptDelegacionArray } from '../../../../adapters/delegacionAdapter';
import { GET_DELEGACIONES_BY_USUARIO } from '../../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario';
import { adaptCategoriasReclamoArray, GET_ALL_CATEGORIAS_RECLAMO } from '../../../../data/graphQL/queries/Reclamos/getAllCategoriasReclamo';

export default function TabCreador({
  isNew,
  editable,
  onChange,
  isEFI,
  idUsuarioLoggeado,
  nombreUsuarioLoggeado,
  etapaCreador,
  reclamoFormData,
  delegacionCargada
}) {
  const [delegaciones, setDelegaciones] = useState([]);
  const [categorias, setCategorias] = useState([]);

  const [getDelegaciones, { data: delegacionesData }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!delegacionesData) return;

    setDelegaciones(adaptDelegacionArray(delegacionesData));
  }, [delegacionesData]);

  const { data: categoriasData } = useQuery(GET_ALL_CATEGORIAS_RECLAMO, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!etapaCreador) {
      setDelegaciones([delegacionCargada]);
    } else {
      getDelegaciones({ variables: { idUsuario: idUsuarioLoggeado } });
    }
  }, [etapaCreador, idUsuarioLoggeado]);

  useEffect(() => {
    if (categoriasData) {
      setCategorias(adaptCategoriasReclamoArray(categoriasData));
    }
  }, [categoriasData]);

  const updatedInputs = useMemo(() => {
    return structuredClone(inputs).
      filter((input) => isEFI ? !input.onlyReclamo : !input.onlyEfi).
      map((input) => {
        const updatedInput = { ...input };
        switch (input.name) {
          case 'usuario':
            updatedInput.type = idUsuarioLoggeado === reclamoFormData?.stage2?.idUsuarioResponsable && isEFI ? 'password' : 'string';
            break;
          case 'idDelegacion':
            updatedInput.options = delegaciones.filter((x) => x.displayName !== 'TODAS');
            break;
          case 'idCategoriaReclamo':
            updatedInput.options = categorias.filter((x) => x.displayName !== 'Evento FI');
            break;

          default:
            break;
        }
        if (!editable) {
          updatedInput.disabled = true;
        }
        return updatedInput;
      });
  }, [editable, delegaciones, categorias, isEFI, idUsuarioLoggeado]);

  useEffect(() => {
    if (isNew) {
      const fechaAltaAux = moment().format("yyyy-MM-DD");
      const initialData = {
        fechaRegistro: fechaAltaAux,
        idUsuarioCreador: idUsuarioLoggeado,
        usuario: nombreUsuarioLoggeado
      };
      onChange(initialData);
    }
  }, [isNew, idUsuarioLoggeado, nombreUsuarioLoggeado]);

  const handleInputChange = useCallback((fieldName, value) => {
    onChange({
      [fieldName]: value,
      ...(fieldName === 'idDelegacion' && {
        idPaciente: null,
        idCliente: null,
        profesionales: null
      })
    });
    // onChange({
    //     [fieldName]: value,
    //     // Podemos incluir lógica de transformación específica del campo
    //     ...(fieldName === 'tipoReclamo' && {
    //         prioridadSugerida: value === 'URGENTE' ? 'ALTA' : 'NORMAL'
    //     })
    // });
  }, []);

  const selectedDelegacion = useMemo(() =>
    delegaciones?.find((del) => del.id === reclamoFormData?.stage1?.idDelegacion),
    [delegaciones, reclamoFormData?.stage1?.idDelegacion]
  );

  const isFieldsDisabled = !reclamoFormData?.stage1?.idDelegacion || !editable;

  return (
    <div>
      <Grid container spacing={2}>
        {updatedInputs.
          map((input, index) =>
            <Fragment key={`input-${input.name}-index-${index}`}>
              {
                input.name !== 'idPaciente' &&
                input.name !== 'idCliente' &&
                input.name !== 'profesionales' &&
                input.name !== 'productos' &&
                <Grid size={{ xs: 12, md: input.col }}>
                  <RenderInputByTypeMobile
                    key={`input-${input.name}-index-${index}`}
                    input={input}
                    handleChange={handleInputChange}
                    value={reclamoFormData?.stage1[input.name]} />

                </Grid>

              }
              {input.name === 'idPaciente' &&
                <Grid size={{ xs: 12, md: 3 }}>
                  <PacienteField
                    onChange={handleInputChange}
                    idPaciente={reclamoFormData?.stage1?.idPaciente}
                    disabled={isFieldsDisabled}
                    idDelegacion={reclamoFormData?.stage1?.idDelegacion} />

                </Grid>
              }
              {input.name === 'idCliente' &&
                <Grid size={{ xs: 12, md: 3 }}>
                  <FinanciadorField
                    onChange={handleInputChange}
                    idCliente={reclamoFormData?.stage1?.idCliente}
                    disabled={isFieldsDisabled}
                    idDelegacion={reclamoFormData?.stage1?.idDelegacion}
                    codDelegacion={selectedDelegacion?.cod} />

                </Grid>
              }
              {input.name === 'profesionales' &&
                <GroupedContainer sectionTitle='Profesionales'>
                  <Grid size={{ xs: 100 }}>
                    <ProfesionalField
                      onChange={handleInputChange}
                      profesionales={reclamoFormData?.stage1?.profesionales || []}
                      disabled={isFieldsDisabled}
                      idDelegacion={reclamoFormData?.stage1?.idDelegacion} />

                  </Grid>
                </GroupedContainer>
              }
              {input.name === 'productos' &&
                <GroupedContainer sectionTitle='Productos'>
                  <Grid container size={{ xs: 100 }}>
                    <GrillaProductosField
                      onChange={handleInputChange}
                      title='Cajas, descartables y nutrición'
                      entityName='productos'
                      noRowsLabel='No se cargó ningún producto'
                      value={reclamoFormData?.stage1?.productos}
                      disabled={!editable} />

                  </Grid>
                  <Grid container size={{ xs: 100 }}>
                    <GrillaProductosField
                      onChange={handleInputChange}
                      title='Tecnología Médica'
                      entityName='tecnologiasMedicas'
                      noRowsLabel='No se cargó ninguna tecnología médica'
                      value={reclamoFormData?.stage1?.tecnologiasMedicas}
                      disabled={!editable} />

                  </Grid>
                </GroupedContainer>
              }
            </Fragment>
          )}
      </Grid>
    </div>);

}

const inputs = [
  //row
  {
    name: 'fechaRegistro',
    displayName: 'Fecha registro',
    type: 'date',
    disabled: true,
    col: 3
  },
  {
    name: 'usuario',
    displayName: 'Usuario',
    type: 'string',
    disabled: true,
    col: 3
  },
  {
    name: 'idDelegacion',
    displayName: 'Delegación',
    type: 'select',
    options: [],
    col: 3
  },
  {
    name: 'fechaOcurrencia',
    disableFuture: true,
    displayName: 'Fecha Ocurrencia',
    type: 'date',
    col: 3
  },
  //row
  {
    name: 'contacto',
    displayName: 'Contacto',
    onlyReclamo: true,
    type: 'string',
    col: 3
  },
  {
    name: 'telefonoContacto',
    displayName: 'Tel. contacto',
    onlyReclamo: true,
    type: 'string',
    col: 3
  },
  {
    name: 'idCategoriaReclamo',
    displayName: 'Categorización',
    onlyReclamo: true,
    type: 'select',
    options: [],
    col: 3
  },
  {
    name: 'spacing',
    displayName: 'spacing',
    onlyReclamo: true,
    type: 'spacing',
    col: 3
  },
  {
    name: 'idPaciente',
    displayName: 'Paciente',
    col: 3,
    type: 'search'
  },
  {
    name: 'idCliente',
    displayName: 'Financiador',
    col: 3,
    type: 'search'
  },
  {
    name: 'empleado',
    displayName: 'Empleado',
    onlyEfi: true,
    col: 3,
    type: 'string'
  },
  {
    name: 'profesionales',
    displayName: 'profesionales',
    col: 3,
    type: 'search'
  },
  {
    name: 'productos',
    displayName: 'productos',
    col: 3,
    type: 'search'
  },
  {
    name: 'descripcion',
    displayName: 'Descripción',
    type: 'long_string',
    required: true,
    disabled: false,
    col: 6
  },
  {
    name: 'accionInmediata',
    displayName: 'Acción Inmediata',
    type: 'long_string',
    disabled: false,
    col: 6
  }];